import React from 'react'
import { Typography, Stack, Divider } from '@mui/material';
import Chips from '../chips/chips';

export default function Benefits({benefits}) {
  return (
    <Stack direction="row" sx={{
        flexDirection: {
            xs: 'column',
            md: 'row'
        },
        gap: {xs: 2, md: "60px"},
        marginBottom: { xs: 3, md: 0}

    }}>
        <Stack minWidth="20%" alignItems="flex-end" sx={{
            alignItems: {
                xs: 'flex-start',
                md: 'flex-end'
            }
        }}>
            <Typography fontSize="24px" fontWeight={600}>Our benefits</Typography>
        </Stack>

        <Stack flexGrow={1}>
            <Chips items={benefits} />
        </Stack>
    </Stack>
  )
}
